export default {
	dailyVacation: 'اليومية',
	hourlyVacation: 'الساعية',

	tabs: {
		work: 'الدوام',
		vacation: 'الإجازات',
		mission: 'الأذونات',
	},
	buttons: {
		addVacation: 'إضافة إجازة',
		addMission: 'إضافة إذن',
		changeWorkType: 'تغير نظام دوام',
		addWorkDay: 'إضافة يوم دوام',
	},
	workTable: {
		section: 'القسم',
		date: 'التاريخ',
		startTime: 'وقت الوصول',
		endTime: 'وقت المغادرة',
		duration: 'المدة',
		delay: 'التأخير',
		earlyLeave: 'الانصراف المبكر',
		extra: 'إضافي',
	},
	vacationTable: {
		requestDate: 'تاريخ الطلب',
		type: 'النوع',
		startDate: 'تاريخ البداية',
		endDate: 'تاريخ النهاية',
		cause: 'السبب',
		status: 'حالة الإجازة',
		timeType: 'النوع',
		duration: 'المدة',
	},
	workType: {
		title: 'تغير نظام الدوام',
		name: 'نظام الدوام',
		totalHours: 'عدد ساعات في الاسبوع',
		vacations: 'ايام العطل',
	},
};
